window.app = window.app || {};
window.app.cw = window.app.cw || {};
window.app.cw.common = window.app.cw.common || {};

app.cw.common.util = {
    bsInitPopovers: function (selector) {
        var sel = !selector ? '' : selector + ' ';
        const popoverTriggerList = document.querySelectorAll(sel + '[data-bs-toggle="popover"]');
        const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl, { html: true, trigger: 'hover focus' }));
    },
    getUrlQueryParams: function (url) {
        // http://stackoverflow.com/a/1099670/1814739
        url = typeof url !== 'undefined' ? url : window.location.href;
        var vars = {};
        var parts = url.replace(/[?&]+([^=&]+)=([^&#]*)/gi, function (m, key, value) {
            vars[key] = value;
        });
        return vars;
    },
    getPathFromUrl: function (url) {
        // https://stackoverflow.com/a/2541083/1814739
        if (!url) {
            return false;
        }
        return url.split(/[?#]/)[0];
    },
    confirmModal: function (opts, callback) {
        var selector = typeof opts.selector !== 'undefined'
            ? opts.selector
            : '#cw_ifg_ajax_layoutbase_common_confirm_prompt_modal';

        var $el = $(selector);
        if (!$el.length) {
            console.log('Element not found. Wrong selector? ' + selector);
            return false;
        }

        const isBackdropped = typeof opts.backdrop != 'undefined'
            ? opts.backdrop
            : true;

        var $modal = new bootstrap.Modal($el, {
            backdrop: isBackdropped
        });
        $modal.show();

        var $title = $el.find('.modal-title');
        var $msg = $el.find('.modal-body p');

        var $yesBtn = $('button[data-ifg-btn-action="yes"]', $el);
        var $noBtn = $('button[data-ifg-btn-action="no"]', $el);
        var $cancelBtn = $('a[data-ifg-btn-action="cancel"]', $el).addClass('d-none');

        var doShowCancelBtn = typeof opts.doShowCancel !== 'undefined'
            ? opts.doShowCancel
            : false;

        var titleText = typeof opts.title !== 'undefined'
            ? opts.title
            : 'Please Confirm';

        var msgText = typeof opts.msg !== 'undefined'
            ? opts.msg
            : typeof opts !== 'object'
                ? opts
                : 'Are you sure you would like to take action?';

        $title.text(titleText);
        $msg.html(msgText);

        if (doShowCancelBtn) {
            $cancelBtn.removeClass('d-none');
        }

        $yesBtn.off('click').on('click', function () {
            if (callback && typeof (callback) === 'function') {
                callback(true);
            }
            $modal.hide();
        });

        $noBtn.off('click').on('click', function () {
            if (callback && typeof (callback) === 'function') {
                callback(false);
            }
            $modal.hide();
        });
    },
    getActiveKendoTabNumber: function (e) {
        // useful when active tab needs to be posted to the server
        var $el = $(e.contentElement);
        var id = $el.attr('id');
        var parts = id.split('-');
        var num = parts[parts.length - 1] * 1;
        num = num - 1;
        return num;
    },
    setNoEnterSubmitOnKeypress: function () {
        // apply class to input element will prevent
        // form submission on return/enter key press
        $(document.body).on('keypress', '.cw_no_enter_submit', function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                return false;
            }
        });
    },
    toggleInvalidInput: function (validationErrorDictionary) {
        $('.is-invalid').removeClass('is-invalid');
        $.each(validationErrorDictionary, function (key, value) {
            if (key) {
                // apply invalid style
                const parentSpan = $('#' + key).parents('span');
                if (parentSpan.length)
                    parentSpan.last().addClass('is-invalid');

                $('#' + key).addClass('is-invalid');
            }
        });
    },
    preventKendoComboBoxPostValueNotInList: function (e) {
        // valid ids can be entered into a combobox
        // and then posted and saved to the database
        // this is bad. please use in change event of
        // all kendo combobox widgets

        // method should be used in conjunction with
        // supressing form submit upon enter key
        // see: setNoEnterSubmitOnKeypress method

        // http://stackoverflow.com/a/18887535/1814739
        // https://docs.telerik.com/kendo-ui/controls/editors/combobox/how-to/customize/prevent-custom-values
        var widget = e.sender;
        if (widget) {
            if (widget.selectedIndex === -1) {
                widget.value('');
            }
        }
    },
    removeUrlQueryParams: function (url) {
        var newUrl = url.split('?')[0]
        window.history.pushState({}, document.title, newUrl);
    },
    initFcwedButton: function initFcwedButton(selector) {
        sel = (!selector) ? '' : selector + ' ';
        // check to see if element is in viewport
        // http://upshots.org/javascript/jquery-test-if-element-is-in-viewport-visible-on-screen
        $.fn.isOnScreen = function () {

            var win = $(window);

            var viewport = {
                top: win.scrollTop(),
                left: win.scrollLeft()
            };
            viewport.right = viewport.left + win.width();
            viewport.bottom = viewport.top + win.height();

            var bounds = this.offset();
            if (!bounds) {
                return false;
            }

            bounds.right = bounds.left + this.outerWidth();
            bounds.bottom = bounds.top + this.outerHeight();

            return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
        };

        // check if page height exceeds the viewport
        $.fn.hasScrollBar = function () {
            return ($(document).height() - $('#cw_footer').outerHeight()) > $(window).height();
        }

        $(function () {
            var saveBtn = $(sel + '.cw_ajax_fcwed_btn_container');
            var stopFcwedBtn = $(sel + '.cw_ajax_stop_fcwed_btn');

            // only show fcwed btns for pages with scrollbars (run past viewport)
            if ($('body').hasScrollBar() == true) {
                saveBtn.addClass('cw_fcwed_btn_css');
            }

            // show fcwed btns until we reach the bottom of the page
            $(window).scroll(function () {
                if (stopFcwedBtn.isOnScreen() == true) {
                    saveBtn.removeClass('cw_fcwed_btn_css');
                }
                else {
                    saveBtn.addClass('cw_fcwed_btn_css');
                }
            });

            // prevent the focused field from being covered by fcwed btns
            var inFocus = false;
            $('input, textarea, select, button').on('focus', function () {
                inFocus = true;
                var focusedBottom = $(this).offset().top + $(this).outerHeight(); // bottom position of focused element
                saveBtnTop = saveBtn.offset().top; // top position of fcwed btns

                if (saveBtnTop < focusedBottom) { // if focused field is covered by the fcwed buttons, scroll window up by the height of the save btns
                    var saveBtnHeight = $(window).scrollTop() + saveBtn.outerHeight();
                    $(window).scrollTop(saveBtnHeight);
                }
            });
        });
    },
    initResponsiveTable: function initResponsiveTable(sel) {
        // show the thead for table on small screen (AccountNew - financial step)
        // see: https://stackoverflow.com/questions/25802776/responsive-tables-show-thead-elements-content-in-corresponding-tds
        var table = $(sel);
        table.find('tbody tr').each(function () {
            $(this).find('td').each(function (i) {
                $(this).attr('data-col', table.find('thead tr th:eq(' + (i + 1) + ')').html());
            });
        });
    },
    findFilterValueByFieldName: function (fieldName, event) {
        var result = '';
        if (!event || !fieldName)
            return result;

        if (event.filter !== undefined && event.filter.filters.length) {
            var filter = $.grep(event.filter.filters, function (obj) {
                return obj.field === fieldName;
            });
            if (filter.length) {
                result = $.trim(filter[0].value);
            }
        }
        return result;
    },
    onRemoveKendoGridRowEvent: function (e, opts) {

        const msg = opts && opts.msg
            ? opts.msg
            : 'Are you sure you want to remove?';

        const dfd = $.Deferred();
        const $el = $(e.currentTarget);

        const $gridEl = $el.parents('[data-role="grid"]');
        const $grid = $gridEl.data('kendoGrid');

        const $tr = $el.closest('tr');

        // correct url must be set on href
        const href = $el.attr('href');
        const url = this.getPathFromUrl(href);
        const data = this.getUrlQueryParams(href);

        this.confirmModal(msg, function (confirm) {
            if (!confirm) {
                dfd.resolve();
            }
            else {
                $.ajax({
                    url: url,
                    method: 'post',
                    dataType: 'json',
                    data: data
                }).done(function (res) {
                    $grid.removeRow($tr);
                    dfd.resolve(res);
                }).fail(function (err) {
                    console.log(err);
                    dfd.reject();
                });
            }
        });

        return dfd.promise();
    },
    convertUtcDatetimeToLocal: function convertUtcDatetimeToLocal(dateString, formatString) {
        // This will assume the date entered is UTC
        // Set Format
        if (!formatString) {
            formatString = 'MM/DD/YYYY hh:mm A';
        }

        let momentDate = moment(dateString).format('YYYY-MM-DD HH:mm:ss');
        let stillUtc = moment.utc(momentDate);
        let local = moment(stillUtc.toDate()).local();

        return local.format(formatString);
    }
};